// extracted by mini-css-extract-plugin
export default {"connectButtons__btnConnect":"DynamicCategoryTable_connectButtons__btnConnect__2ADHb","bg-QuickbooksDesktop":"DynamicCategoryTable_bg-QuickbooksDesktop__LZJ87"};